import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface TreeNodeState {
  disabled: boolean;
  selected: boolean;
  opened: boolean;
}

interface TreeNodeLiAttr {
  isCascadeEnabled: boolean;
}

interface TreeNode {
  id: string;
  text: string;
  parent: string;
  isGroup: boolean;
  type: string;
  searchGroupTypeCode: string;
  a_attr: string;
  isSelected: boolean;
  state: TreeNodeState;
  li_attr: TreeNodeLiAttr;
  saveSearchSecurityGroupId: number;
  documentCount: number;
  textWithoutCount: string;
}

interface IProductionState {
  securityGroupId: number;
  editModeProductionId: number;
  productionSetId: number;
  redactionTagList: TreeNode[];
  isFieldsChanged?: boolean;
}

const initialState: IProductionState = {
  securityGroupId: 0,
  productionSetId: 0,
  editModeProductionId: 99999,
  redactionTagList: [],
  isFieldsChanged: false,
};
const reproductionSlice = createSlice({
  name: 'reproduction',
  initialState,
  reducers: {
     setProduction: (
      state,
      action: PayloadAction<{
        securityGroupId: number;
        productionSetId: number;
      }>
    ) => {
      state.securityGroupId = action.payload.securityGroupId;
      state.productionSetId = action.payload.productionSetId;
    },
    clearProduction: (state) => {
      state.securityGroupId = 0;
      state.productionSetId = 0;
    },

    setSecurityGroupId: (state, action: PayloadAction<number>) => {
      state.securityGroupId = action.payload;
    },
    clearSecurityGroupId: (state) => {
      state.securityGroupId = 0;
    },

    setProductionSetSetId: (state, action: PayloadAction<number>) => {
      state.productionSetId = action.payload;
    },
    clearProductionSetId: (state) => {
      state.productionSetId = 0;
    },
    setRedactionTagList: (state, action: PayloadAction<TreeNode[]>) => {
      state.redactionTagList = action.payload;
    },

    setEditModeProductionId: (state, action: PayloadAction<number>) => {
      state.editModeProductionId = action.payload;
    },

    setReproductionIsFieldsChanged(
      state,
      action: PayloadAction<{isFieldsChanged: boolean}>
    ) {
      state.isFieldsChanged = action.payload.isFieldsChanged;
    },
  },
});

export const {
  setProduction,
  clearProduction,
  setSecurityGroupId,
  clearSecurityGroupId,
  setProductionSetSetId,
  clearProductionSetId,
  setRedactionTagList,
  setEditModeProductionId,
  setReproductionIsFieldsChanged,
} = reproductionSlice.actions;
export default reproductionSlice.reducer;
